/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_LifestyleInputs */

const en_us2_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short sleep and heavy work lower the plan's volume, so you can recover.`)
};

const pt_br2_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono curto e trabalho pesado reduzem o volume do plano, para você se recuperar.`)
};

const es_419_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dormir poco y un trabajo pesado bajan el volumen del plan, para que te recuperes.`)
};

const pt_pt2_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouco sono e trabalho pesado reduzem o volume do plano, para conseguires recuperar.`)
};

const fr_fr2_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sommeil court et un travail physique réduisent le volume du programme, pour que tu récupères.`)
};

const de_de2_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenig Schlaf und harte Arbeit senken das Volumen des Plans, damit du dich erholen kannst.`)
};

const it_it2_profile_why_lifestyle = /** @type {(inputs: Profile_Why_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poco sonno e un lavoro pesante riducono il volume della scheda, così recuperi.`)
};

/**
* | output |
* | --- |
* | "Short sleep and heavy work lower the plan's volume, so you can recover." |
*
* @param {Profile_Why_LifestyleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_lifestyle = /** @type {((inputs?: Profile_Why_LifestyleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_LifestyleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_lifestyle(inputs)
	if (locale === "es-419") return es_419_profile_why_lifestyle(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_lifestyle(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_lifestyle(inputs)
	if (locale === "de-DE") return de_de2_profile_why_lifestyle(inputs)
	if (locale === "it-IT") return it_it2_profile_why_lifestyle(inputs)
	return en_us2_profile_why_lifestyle(inputs)
});
export { profile_why_lifestyle as "profile.why_lifestyle" }